import React, { useEffect, useState } from "react";
import backArrow from "../../../imgs/BackArrow.svg";
import MainTemplate from "../../templates/MainTemplate";
import { useNavigate } from "react-router-dom";
import { Snackbar } from "@mui/material";
import { useParams } from "react-router-dom";
import Grid from "@mui/material/Grid";
import InfoInput from "../../atoms/InfoInput";
import { updateSurvey } from "../../../api/services/services";
import MuiAlert from "@mui/material/Alert";
import { getSingleSurvey } from "../../../api/services/services";
import { Typography, CircularProgress, Box } from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import SectionHeader from "../../molecules/SectionHeader";
import DescriptionIcon from "@mui/icons-material/Description";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import PremiumCard from "../../molecules/PremiumCard";

const CompleteSurvey = () => {
  const { id, status } = useParams();
  const navigate = useNavigate();
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    description: "",
    loadPlacePhone: "",
    loadPlaceStAddress: "",
    loadPlaceZip: "",
    loadPlaceCountry: "",
    loadPlaceCity: "",
    loadDate: null,
    unloadPlacePhone: "",
    unloadPlaceStAddress: "",
    unloadPlaceZip: "",
    unloadPlaceCountry: "",
    unloadPlaceCity: "",
    status: status,
    surveyDate: null
  });
  const [unixDate, setUnixDate] = useState(null);
  const [unixDateSurvey, setUnixDateSurvey] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const handleCloseSnackbar = () => setOpenSnackbar(false);

  const handleSubmit = () => {
    setIsLoading(true);
    let data = { ...formData };
    data.loadDate = unixDate;
    data.surveyDate = unixDateSurvey;
    data.loadPlaceZip = formData.loadPlaceZip ? parseInt(formData.loadPlaceZip) : null;
    data.unloadPlaceZip = formData.unloadPlaceZip ? parseInt(formData.unloadPlaceZip) : null;
    data.status = status;

    updateSurvey(data, id).then(() => {
      setSnackbarMessage("Survey details updated successfully!");
      setOpenSnackbar(true);
      setTimeout(() => navigate(-1), 1500);
    }).catch((error) => {
      setIsLoading(false);
      if (error?.response?.data?.statusCode == 401) {
        localStorage.clear(); window.location.pathname = "/login";
      } else {
        setSnackbarMessage(error?.response?.data?.message || "Error updating survey");
        setOpenSnackbar(true);
      }
    });
  };

  const getSurvey = () => {
    getSingleSurvey(id).then((res) => {
        const d = res?.data?.data;
        if (d) {
          setFormData({
              ...formData,
              name: d.name || "",
              email: d.email || "",
              phone: d.phone || "",
              description: d.description || "",
              loadPlacePhone: d.loadPlacePhone || "",
              loadPlaceStAddress: d.loadPlaceStAddress || "",
              loadPlaceZip: d.loadPlaceZip || "",
              loadPlaceCountry: d.loadPlaceCountry || "",
              loadPlaceCity: d.loadPlaceCity || "",
              unloadPlacePhone: d.unloadPlacePhone || "",
              unloadPlaceStAddress: d.unloadPlaceStAddress || "",
              unloadPlaceZip: d.unloadPlaceZip || "",
              unloadPlaceCountry: d.unloadPlaceCountry || "",
              unloadPlaceCity: d.unloadPlaceCity || "",
              loadDate: d.loadDate ? new Date(d.loadDate * 1000).toISOString().split('T')[0] : null,
              surveyDate: d.surveyDate ? new Date(d.surveyDate * 1000).toISOString().split('T')[0] : null
          });
          if(d.loadDate) setUnixDate(d.loadDate);
          if(d.surveyDate) setUnixDateSurvey(d.surveyDate);
        }
    }).catch(err => console.error(err));
  };

  useEffect(() => { getSurvey(); }, []);

  const disableSubmit = !formData.name || !formData.email || !formData.loadPlacePhone || 
                        !formData.loadPlaceStAddress || !formData.loadPlaceCountry || 
                        !formData.loadPlaceCity || !formData.loadDate || !formData.surveyDate || 
                        !formData.unloadPlaceStAddress || !formData.unloadPlaceCountry || !formData.unloadPlaceCity;

  return (
    <>
      <MainTemplate>
          <div className="page-header-container d-flex align-items-center mb-5">
              <div className="d-flex align-items-center">
                  <div 
                      className="back-bg cursor-pointer me-3" 
                      onClick={() => navigate(-1)} 
                      style={{ 
                          background: 'rgba(15, 23, 42, 0.05)', 
                          padding: '10px', 
                          borderRadius: '12px',
                          transition: 'all 0.2s'
                      }}
                  >
                      <img src={backArrow} height="20" width="20" alt="Back" />
                  </div>
                  <div>
                    <Typography variant="h1" className="gradient-title" sx={{ fontSize: '2rem !important', mb: 0 }}>
                        Finalize Survey
                    </Typography>
                    <Typography variant="body2" sx={{ color: 'var(--gray-500)', fontWeight: 500 }}>
                        Verify and update logistics details to complete the survey process
                    </Typography>
                  </div>
              </div>
              <div className="ms-auto">
                  <button 
                      className="btn-premium" 
                      disabled={disableSubmit || isLoading} 
                      onClick={handleSubmit}
                      style={{ padding: '12px 32px' }}
                  >
                      {isLoading ? (
                           <div className="d-flex align-items-center gap-2">
                               <CircularProgress size={16} color="inherit" />
                               <span>Saving...</span>
                           </div>
                      ) : (
                          <div className="d-flex align-items-center gap-2">
                              <CheckCircleIcon sx={{ fontSize: 18 }} />
                              <span>Update Detail</span>
                          </div>
                      )}
                  </button>
              </div>
          </div>

        <Box sx={{ maxWidth: '1100px', mx: 'auto', pb: 6 }}>
            <SectionHeader title="Origin Information" icon={<DescriptionIcon />} />
            <PremiumCard sx={{ p: { xs: 3, md: 5 }, mb: 5 }}>
              <Grid container spacing={3}>
                {/* Personal Info Row */}
                <Grid item xs={12} sm={6}>
                  <label className="premium-label">Client Name</label>
                  <InfoInput type="text" value={formData.name} placeholder="Enter Name..."
                    onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <label className="premium-label">Client Email</label>
                  <InfoInput type="email" value={formData.email} placeholder="Enter Email..."
                    onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <label className="premium-label">Client Phone</label>
                  <InfoInput type="text" value={formData.phone} placeholder="Enter Phone Number..."
                    onChange={(e) => setFormData({ ...formData, phone: e.target.value })}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <label className="premium-label">Description</label>
                  <InfoInput type="text" value={formData.description} placeholder="Enter Description..."
                    onChange={(e) => setFormData({ ...formData, description: e.target.value })}
                  />
                </Grid>

                <Grid item xs={12}><div style={{ height: '1px', background: '#eee', margin: '10px 0' }}></div></Grid>

                <Grid item xs={12} sm={8}>
                  <label className="premium-label">Street Address</label>
                  <InfoInput type="text" value={formData.loadPlaceStAddress} placeholder="Enter full collection address"
                    onChange={(e) => setFormData({ ...formData, loadPlaceStAddress: e.target.value })}
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <label className="premium-label">City</label>
                  <InfoInput type="text" value={formData.loadPlaceCity} placeholder="City"
                    onChange={(e) => setFormData({ ...formData, loadPlaceCity: e.target.value })}
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <label className="premium-label">Country</label>
                  <InfoInput type="text" value={formData.loadPlaceCountry} placeholder="Country"
                    onChange={(e) => setFormData({ ...formData, loadPlaceCountry: e.target.value })}
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <label className="premium-label">Zip Code</label>
                  <InfoInput type="text" value={formData.loadPlaceZip} placeholder="Zip"
                    onChange={(e) => setFormData({ ...formData, loadPlaceZip: e.target.value })}
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <label className="premium-label">Origin Phone</label>
                  <InfoInput type="text" value={formData.loadPlacePhone} placeholder="Primary Phone"
                    onChange={(e) => setFormData({ ...formData, loadPlacePhone: e.target.value })}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <label className="premium-label">Removal Date</label>
                  <InfoInput type="date" value={formData.loadDate}
                    onChange={(e) => {
                      let temp = parseInt((new Date(e.target.value).getTime() / 1000).toFixed(0));
                      setUnixDate(temp);
                      setFormData({ ...formData, loadDate: e.target.value });
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <label className="premium-label">Survey Date</label>
                  <InfoInput type="date" value={formData.surveyDate}
                    onChange={(e) => {
                      let temp = parseInt((new Date(e.target.value).getTime() / 1000).toFixed(0));
                      setUnixDateSurvey(temp);
                      setFormData({ ...formData, surveyDate: e.target.value });
                    }}
                  />
                </Grid>
              </Grid>
            </PremiumCard>

            <SectionHeader title="Destination Information" icon={<LocalShippingIcon />} />
            <PremiumCard sx={{ p: { xs: 3, md: 5 } }}>
              <Grid container spacing={3}>
                <Grid item xs={12} sm={8}>
                  <label className="premium-label">Street Address</label>
                  <InfoInput type="text" value={formData.unloadPlaceStAddress} placeholder="Enter full delivery address"
                    onChange={(e) => setFormData({ ...formData, unloadPlaceStAddress: e.target.value })}
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <label className="premium-label">City</label>
                  <InfoInput type="text" value={formData.unloadPlaceCity} placeholder="City"
                    onChange={(e) => setFormData({ ...formData, unloadPlaceCity: e.target.value })}
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <label className="premium-label">Country</label>
                  <InfoInput type="text" value={formData.unloadPlaceCountry} placeholder="Country"
                    onChange={(e) => setFormData({ ...formData, unloadPlaceCountry: e.target.value })}
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <label className="premium-label">Zip Code</label>
                  <InfoInput type="text" value={formData.unloadPlaceZip} placeholder="Zip"
                    onChange={(e) => setFormData({ ...formData, unloadPlaceZip: e.target.value })}
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <label className="premium-label">Destination Phone</label>
                  <InfoInput type="text" value={formData.unloadPlacePhone} placeholder="Delivery Phone"
                    onChange={(e) => setFormData({ ...formData, unloadPlacePhone: e.target.value })}
                  />
                </Grid>
              </Grid>
            </PremiumCard>
        </Box>
      </MainTemplate>

      <Snackbar open={openSnackbar} autoHideDuration={6000} onClose={handleCloseSnackbar} anchorOrigin={{ vertical: "top", horizontal: "right" }}>
        <MuiAlert elevation={6} variant="filled" severity={snackbarMessage?.includes("successful") || snackbarMessage?.includes("success") ? "success" : "error"} onClose={handleCloseSnackbar} sx={{ borderRadius: '12px', fontWeight: 600 }}>
          {snackbarMessage}
        </MuiAlert>
      </Snackbar>
    </>
  );
};

export default CompleteSurvey;
